<template>
  <div class="bg">
    <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
      <div class="button">
        <i @click="showSearch = true" class="iconfont icon-chaxun"></i>
        <van-popup
          v-model="showSearch"
          round
          position="bottom"
          :style="{ height: 'auto' }"
        >
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            cancel-button-text=" "
            title="请选择认证开始时间"
            confirm-button-text="先确认"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="StartTime"
          />
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="请选择认证结束时间"
            confirm-button-text="先确认"
            cancel-button-text=" "
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="EndTime"
          />
          <div style="text-align: center; margin-top: 10px">
            开始时间：{{ startTime }}，结束时间：{{ endTime }}
          </div>
          <div class="searchBtn">
            <i style="font-size: 10px">（查询前先选择开始时间和结束时间）</i>
            <el-button type="primary" size="mini" @click="itemList"> 查询记录 </el-button>
          </div>
        </van-popup>
      </div>
      <div v-show="showPagination !== 0">
        <div class="content">
          <el-card v-for="(item, index) in itemInfo" :key="index">
            <el-row>
              <el-col :span="8">
                <div class="img">
                  <div>
                    <van-image
                      height="150"
                      @click="showImage(item.head)"
                      :src="item.head"
                      fit="cover"
                    />
                  </div>
                  <i>（查看大图）</i>
                </div>
              </el-col>
              <div @click="goDetail(item.id)">
                <el-col :span="16">
                  <p>
                    <span>所属项目：{{ project }}</span>
                  </p>
                  <p>
                    <span>联系电话：{{ item.phone }}</span>
                  </p>
                  <p>
                    <span>认证时间：{{ item.createTime }}</span>
                  </p>
                  <p>
                    <span v-if="item.result == '人员认证成功'">
                      认证状态：<el-tag size="small" type="success">
                        {{ item.result }}
                      </el-tag>
                    </span>
                    <span v-else-if="item.result == '等待认证'">
                      认证状态：<el-tag size="small" type="warning">
                        {{ item.result }}
                      </el-tag>
                    </span>
                    <span v-else>
                      认证状态：
                      <el-tag size="small" type="danger">{{ text }}</el-tag>
                    </span>
                  </p>
                </el-col>
                <el-col :span="24" style="text-align:right;">
                  <el-button
                    v-show="item.result.indexOf('失败') !== -1"
                    size="mini"
                    type="primary"
                    @click="goEdit(item.id)"
                  >
                    重新认证
                  </el-button>
                  <el-button size="mini" type="primary" @click="goDetail(item.id)">
                    详情
                  </el-button>
                </el-col>
              </div>
              <div class="handleBtn">
                
              </div>
            </el-row>
          </el-card>
        </div>
        <el-pagination
          :current-page.sync="page.currentPage"
          :page-sizes="page.pageSizes"
          :page-size="page.pageSize"
          :total="page.totalCount"
          layout="sizes ,pager, next "
          :on-load="itemList"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
      <el-card v-show="showPagination == 0" body-style="text-align:center">
        <span>暂无数据</span>
      </el-card>
      <div style="margin-top: 10px; text-align: right">
        <el-button
          v-show="showPagination == 0"
          size="mini"
          type="primary"
          @click="goBack"
        >
          返回
        </el-button>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Toast } from "vant";
import { ImagePreview } from "vant";
import { postProjectId } from "@/api/app/project";
import { postListPage, postRemove } from "@/api/app/certificationRecord";
export default {
  filters: {
    reason(e) {
      return "认证失败";
    },
  },
  data() {
    return {
      showSearch: false,
      project: "",
      itemInfo: [],
      query: {},
      isLoading: false,
      // 分页
      page: {
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
        pageSizes: [10, 20, 30, 40, 50, 100],
      },
      filtrate: "all",
      // 筛选
      selectOption: "all",
      showPagination: Number,
      text: "人员认证失败",
      // 时间
      minDate: new Date(new Date().getFullYear() - 5, 1, 1),
      maxDate: new Date(new Date().getFullYear() + 5, 1, 1),
      currentDate: new Date(),
      startTime: "开始时间",
      endTime: "结束时间",
    };
  },
  computed: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex() {
      return this.$store.state.app.projectId;
    },
  },
  watch: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex(e) {
      if (e !== this.projectId) {
        // 获取项目信息
        this.itemList();
      }
    },
  },
  created() {
    this.itemList();
  },
  methods: {
    // 获取列表信息
    itemList(page, params = {}) {
      // 根据vuex的寸的projectId获取所属项目名称
      postProjectId(this.$store.state.app.projectId).then((res) => {
        this.project = res.data.name;
      });
      if (this.startTime !== "开始时间") {
        this.query.startTime = this.startTime;
      }
      if (this.endTime !== "结束时间") {
        this.query.endTime = this.endTime;
      }
      this.query.projectId = this.$store.state.app.projectId;
      postListPage(
        this.page.currentPage,
        this.page.pageSize,
        Object.assign(params, this.query)
      ).then((res) => {
        this.page = res.data;
        this.showPagination = res.data.result.length;
        this.itemInfo = res.data.result;
        this.showSearch = false;
        res.data.result.forEach((item) => {
          if (item.result == undefined) {
            item.result = "等待认证";
            this.text = "等待认证";
          }
        });
      });
    },
    // 开始时间选择
    StartTime(value) {
      this.startTime = this.datePick.datePick(value).substring(0, 10);
    },
    // 结束时间选择
    EndTime(value) {
      this.endTime = this.datePick.datePick(value).substring(0, 10);
    },
    // 返回
    goBack() {
      if (this.startTime !== "") {
        location.reload();
      } else {
        this.$router.back();
      }
    },
    // 图片预览
    showImage(index) {
      ImagePreview({
        images: [index],
      });
    },
    // 删除列表
    deleteItem(ids) {
      this.$dialog
        .confirm({
          message: "确定删除吗？",
        })
        .then(() => {
          postRemove([ids]).then((res) => {
            this.$notify({ type: "success", message: "删除成功！" });
            this.itemList();
          });
        });
    },
    onRefresh() {
      this.itemList();
      Toast("刷新成功");
      this.isLoading = false;
    },
    // 分页
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.itemList(this.page);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.itemList(this.page);
    },
    //跳转到详情
    goDetail(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: "/certificationRecord/detailedInfo/" });
    },
    // 跳转到编辑页面
    goEdit(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: `/certificationRecord/essentialInfo/${1}` });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  padding: 10px;
  min-height: 100vh;

  background-color: #f0f0f0;
}
.button {
  width: 100%;
  margin-bottom: 10px;
  text-align: right;
  i {
    font-size: 24px;
    color: #606266;
  }
  .van-field:nth-child(1) {
    margin-top: 45px;
  }
  .van-popup {
    padding-bottom: 30px;
  }
  .searchBtn {
    margin-top: 20px;
  }
}
.content {
  .el-card {
    margin-bottom: 10px;
    .el-col {
      font-size: 14px;
      margin-bottom: 5px;
    }
    i {
      font-size: 10px;
      white-space: nowrap;
    }
    p {
      margin: 0 0 15px 5px;
    }
    .handleBtn {
      top: 20px;
      left: 20px;
      text-align: end;
      position: relative;
    }
    .img {
      p {
        margin: 0;
        font-size: 14px;
        font-weight: bold;
      }
      img {
        width: 100px;
        height: 100px;
        border-radius: 4px;
      }
    }
  }
}
// 分页
/deep/ .el-pagination {
  margin-bottom: 30px;
  padding: 0;
  overflow: hidden;
}
/deep/ .el-pagination .el-select .el-input {
  margin: 0;
}
</style>
